import React from 'react';
import { Formik } from 'formik';

import { TranslationKeys } from 'app/translations';

import { useBreadcrumb } from 'app/components';

import { useInsurerGetInsurersQuery } from 'app/hooks';

import { RateTableForm, useRateTableForm } from 'app/Domain/Settings/Components';
import type { RateTableFormValues } from 'app/Domain/Settings/Components/RateTableForm/RateTableForm.types';

import { SettingsRateTableCreateToolbar } from './components';

export const SettingsRateTableCreatePage = () => {
  const { isSubmitting, formikInitialValues, formikValidationSchema, formikOnSubmitCreate } = useRateTableForm();

  const {
    data: insurersData,
    isLoading: isLoadingGetInsurersQuery,
    isFetching: isFetchingGetInsurersQuery,
  } = useInsurerGetInsurersQuery({
    variables: { page: 1, pageSize: 999 },
  });

  const insurers = React.useMemo(() => {
    if (!insurersData) return [];
    return insurersData.data;
  }, [insurersData]);

  const isLoading = isLoadingGetInsurersQuery || isFetchingGetInsurersQuery || isSubmitting;

  useBreadcrumb(TranslationKeys.menu_settings_rateTables, {
    hideTrail: true,
    hideTitle: true,
    otherElements: <SettingsRateTableCreateToolbar isLoading={isLoading} />,
  });

  return (
    <div>
      <Formik<RateTableFormValues>
        initialValues={formikInitialValues}
        validationSchema={formikValidationSchema}
        onSubmit={formikOnSubmitCreate}
      >
        <RateTableForm isLoading={isLoading} insurers={insurers} />
      </Formik>
    </div>
  );
};
